<template>
<div>
    <!-- modal -->
    <b-modal id="nationalTrademarkRenewalsFormModal" ref="nationalTrademarkRenewalsFormModal" centered size="lg" no-close-on-backdrop :title=" $t('nationalTrademarkRenewals.info')" :cancel-title=" $t('others.cancel_title')" :ok-title=" $t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate">
        <validation-observer ref="simpleRules">
            <b-row>
                <b-col class="col-md-6">
                    <label for="national-trademark-renewals-renewal-date-input">{{ $t('nationalTrademarkRenewals.renewal_date') }}</label>
                    <!-- STOCK-2216 -->
                    <!-- <CustomDatePicker :datePickerValidateOption="1" v-model="renewalDate"></CustomDatePicker> -->
                    <CustomDatePicker :datePickerValidateOption="0" v-model="renewalDate"></CustomDatePicker>

                </b-col>
                <b-col class="col-md-6">
                    <label for="national-trademark-renewals-reminder-date-input">{{ $t('nationalTrademarkRenewals.reminder_date') }}</label>
                    <CustomDatePicker :datePickerValidateOption="0" v-model="reminderDate"></CustomDatePicker>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-md-6">
                    <label for="national-trademark-renewals-instruction-date-input">{{ $t('nationalTrademarkRenewals.instruction_date') }}</label>
                    <CustomDatePicker :datePickerValidateOption="0" v-model="instructionDate"></CustomDatePicker>
                </b-col>
                <b-col class="col-md-6">
                    <label for="national-trademark-renewals-next-renewal-date-input">{{ $t('nationalTrademarkRenewals.next_renewal_date') }}</label>
                    <CustomDatePicker :datePickerValidateOption="0" v-model="nextRenewalDate"></CustomDatePicker>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-md-12">
                    <b-form>
                        <label for="trademark-agent-ref-code-input">{{ $t('nationalTrademarkRenewals.trademark_agent_ref_code') }}</label>
                        <b-form-group>
                            <b-form-input id="trademark-agent-ref-code-input" v-model="agentReferenceNo" maxlength="100" />
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-12 mt-1">
                    <b-form-group>
                        <label for="national-trademark-renewals-agent-input"> {{ $t('nationalTrademarkRenewals.agent') }} </label>
                        <b-input-group>
                            <validation-provider :name=" $t('nationalTrademarkRenewals.agent')" #default="{ errors }" :rules="{ excluded: 0 }">
                                <b-form-group label-for="national-trademark-renewals-agent-input" :state="errors.length > 0 ? false:null">
                                    <v-select style="max-width: 100%!important; width: 50em;" id="national-trademark-renewals-agent-input" v-model="nationalTrademarkRenewalAgentSelect" :options="nationalTrademarkRenewalAgentOption" @input="setClientId" class="w-100 custom-v-select agentInput" :get-option-label="$formatAgent" @search="onSearch">
                                    </v-select>
                                    <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                        {{ errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                            <b-input-group-append>
                                <b-dropdown style="width: 4em; height: 2em; margin-bottom: 1em" id="dropdown-grouped" variant="outline-primary" right class="dropdown-icon-wrapper" size="sm">
                                    <template #button-content>
                                        <feather-icon icon="MenuIcon" size="10" class="align-middle" />
                                    </template>
                                    <b-dropdown-item @click="getClientInfo(0)">
                                        <span>{{this.$t('others.add_client')}}</span>
                                    </b-dropdown-item>
                                    <b-dropdown-item @click="getAgentNoteInfo(nationalTrademarkRenewalAgentSelect.clientAccountingId)">
                                        <span>{{this.$t('others.show_note')}}</span>
                                    </b-dropdown-item>
                                    <b-dropdown-item @click="getClientInfo(nationalTrademarkRenewalAgentSelect.clientId)">
                                        <span>{{this.$t('others.show_agent')}}</span>
                                    </b-dropdown-item>
                                </b-dropdown>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
        </validation-observer>
    </b-modal>
</div>
</template>

<script>
export default {
    props: {
        // nationalTrademarkId: Number,
        getNationalTrademarkRenewalsList: {
            type: Function
        },
        getNationalTrademarkList: {
            type: Function
        },
    },
    data() {
        return {
            id: 0,
            reminderDate: null,
            instructionDate: null,
            renewalDate: null,
            nextRenewalDate: null,
            agentReferenceNo: '',
            nationalTrademarkRenewalAgentSelect: 0,
            nationalTrademarkRenewalAgentOption: [],
        }
    },
    methods: {
        async getAgentNoteInfo(clientAccountingId) {
            this.$refs.agentNoteFormModal.getNoteListByAccountingId(clientAccountingId)
        },
        async getClientInfo(clientId) {
            this.$refs.clientFormModal.showInfo(clientId)
        },
        setClientId(event) {
            if (event != null) {
                this.clientId = event.clientId
            } else {
                this.clientId = null;
            }
        },
        onSearch(search, loading) {
            if (search.length) {
                loading(true);
                this.search(loading, search, this);
            }
        },
        search(loading, search, vm) {
            if (search.length > 2) {
                const data = {
                    clientAccountingId: 0,
                    clientName: search,
                    forAgentOrInvoice: 1
                }
                const controller = {
                    name: 'ClientAccounting',
                    actionName: 'GetClientAccountingByClientName'
                }
                const payload = {
                    data: data,
                    controller: controller
                }
                this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                    this.nationalTrademarkRenewalAgentOption = response.data.clientList
                    loading(false)
                })
            }
        },
        showInfo(id, nationalTrademarkId) {
            this.$refs['nationalTrademarkRenewalsFormModal'].show()
            this.id = id
            this.nationalTrademarkId = nationalTrademarkId
            const data = {
                id: this.id
            }
            const controller = {
                name: 'NationalTrademarkRenewal'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.instructionDate = response.data.nationalTrademarkRenewal.instructionDate
                    this.reminderDate = response.data.nationalTrademarkRenewal.reminderDate
                    this.renewalDate = response.data.nationalTrademarkRenewal.renewalDate
                    this.nextRenewalDate = response.data.nationalTrademarkRenewal.nextRenewalDate
                    this.agentReferenceNo = response.data.nationalTrademarkRenewal.agentReferenceNo
                    if (response.data.nationalTrademarkRenewal.clientAccountingId > 0) {
                        const clientAccountingData = {
                            clientAccountingId: response.data.nationalTrademarkRenewal.clientAccountingId
                        }
                        const clientAccountingController = {
                            name: 'ClientAccounting',
                            actionName: 'GetClientAccountingByClientName'
                        }
                        const clientAccountingPayload = {
                            data: clientAccountingData,
                            controller: clientAccountingController
                        }
                        this.$store.dispatch('moduleAuth/customService', clientAccountingPayload).then((clientAccountingResponse) => {
                            this.nationalTrademarkRenewalAgentOption = clientAccountingResponse.data.clientList
                            this.nationalTrademarkRenewalAgentSelect = clientAccountingResponse.data.clientList[0]
                            this.clientId = clientAccountingResponse.data.clientList[0].clientId
                        })
                    } else {
                        this.trademarkRenewalAgentOption = []
                        this.trademarkRenewalAgentSelect = 0;
                    }

                } else {
                    this.$bvModal.hide('nationalTrademarkRenewalsFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        addOrUpdate() {
            const data = {
                id: this.id,
                nationalTrademarkId: this.nationalTrademarkId,
                instructionDate: this.instructionDate,
                reminderDate: this.reminderDate,
                renewalDate: this.renewalDate,
                nextRenewalDate: this.nextRenewalDate,
                agentReferenceNo: this.agentReferenceNo,
                clientAccountingId: this.nationalTrademarkRenewalAgentSelect.clientAccountingId
            }
            const controller = {
                name: 'NationalTrademarkRenewal'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$refs.simpleRules.validate().then(success => {
                if (success) {
                    this.$store.dispatch('moduleAuth/save', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.$bvModal.hide('nationalTrademarkRenewalsFormModal')
                            this.getNationalTrademarkRenewalsList()
                            this.$SaveAlert()
                            this.nationalTrademarkRenewalAgentSelect = 0
                            this.nationalTrademarkRenewalAgentOption = []
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                        }
                    })
                }
            })
        },
    }
}
</script>

<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}

[dir] .vs__selected-options {
    padding: 0 2px;
    font-size: 0.9em;
}

.datepickerStyle {
    max-height: 2.2em;
    font-family: fangsong;
}

.agentInput {
    max-width: 87em !important;
    width: 86em !important;
}

.custom-v-select .vs__selected,
.custom-v-select .vs__dropdown-option {
    white-space: pre-wrap !important;
}
</style>
